import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from './en';
import { zhCN } from './zh-CN';

export const supportedLngs = ['en', 'zh-CN'] as const;
export type SupportedLng = (typeof supportedLngs)[number];

const resources = {
  en: { translation: en },
  'zh-CN': { translation: zhCN },
} as const;

void i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: detectInitialLanguage(),
    fallbackLng: 'en',
    supportedLngs: supportedLngs as unknown as string[],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  })
  .catch((error: unknown) => {
    console.error('i18n init failed', error);
  });

function detectInitialLanguage(): SupportedLng {
  if (typeof navigator === 'undefined') return 'en';
  const stored = localStorage.getItem('i18nextLng');
  if (stored && (supportedLngs as readonly string[]).includes(stored)) {
    return stored as SupportedLng;
  }
  const browser = navigator.language.toLowerCase();
  if (browser.startsWith('zh')) return 'zh-CN';
  return 'en';
}

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
